// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"135":"group-auth","638":"group-admin"}[chunkId] + "." + {"135":"5e62562b","638":"54a12e7b"}[chunkId] + ".css";
};